export const EnvironmentApiKeyAttributeKeys = {
	value: 'ApiKey:Value',
	hash: 'ApiKey:Hash',
	hashAlgorithm: 'ApiKey:HashAlgorithm',
	updatedAt: 'ApiKey:UpdatedAt',
};

export const environmentApiKeyAttributeRows = [
	{ key: EnvironmentApiKeyAttributeKeys.value, label: 'API Key', secret: true },
	{ key: EnvironmentApiKeyAttributeKeys.hash, label: 'Hash', secret: false },
	{ key: EnvironmentApiKeyAttributeKeys.hashAlgorithm, label: 'Hash Algorithm', secret: false },
	{ key: EnvironmentApiKeyAttributeKeys.updatedAt, label: 'Updated At', secret: false },
];

export const knownEnvironmentApiKeyAttributeKeys: ReadonlySet<string> = new Set(environmentApiKeyAttributeRows.map((row) => row.key));
